/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description Affichage de la page about.

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React from "react";
import Template from "./Template";
import "./about.scss";

const About = () => {
	return (
		<Template bigLogo={false}>
			<div className="about__page">
				<h1 className="about__title">À propos</h1>
				<p className="about__p">
					Constituée en 2019 suite à la décision de financement, via le programme <a href="https://www.seco.admin.ch/dam/seco/fr/dokumente/Publikationen_Dienstleistungen/Publikationen_Formulare/Standortfoerderung/Broschueren/Die%20Neue%20Regionalpolitik%20des%20Bundes.pdf.download.pdf/seco-nrp-broschure-fr.pdf" target="_blank" rel="noreferrer">NPR</a>,
					du projet NEDAO, l&apos;Association éponyme comprend des acteurs économiques, académiques et institutionnels du Canton de Neuchâtel,
					dont l&apos;intérêt commun est développer les compétences régionales sur les sujets des nouvelles technologies de la décentralisation,
					aussi bien dans le monde de l&apos;entreprise que pour le grand public, qui sera de plus en plus amené à intéragir avec ces nouveaux paradigmes dans les années à venir.
				</p>
			</div>
		</Template>
	);
};

export default About;
